import { DateTime } from 'luxon'

export type OptionObject = {
  value: string
  label: string
}

export function generateArrayObjects(): OptionObject[] {
  const currentYear = DateTime.now().year
  const arrayObjects: OptionObject[] = []

  for (let year = currentYear; year >= 2000; year--) {
    const arrayObject: OptionObject = {
      value: `${year}`,
      label: `${year}`,
    }

    arrayObjects.push(arrayObject)
  }

  return arrayObjects
}
